"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const mapUsefulAddressList = (0, graphql_tag_1.default)`
  query map_useful_address_list($filtersList: [FilterCoreInput], $search: String) {
    usefulAddress {
      list(filters: $filtersList, search: $search) {
        edges {
          node {
            id
            title
            lat
            lng
            isFavorite
          }
        }
      }
    }
  }
`;
exports.default = mapUsefulAddressList;